import React, { useState } from "react";
import { api, formatApiError } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { toast } from "sonner";
import { Loader2, Mail } from "lucide-react";

export const ChangeEmail = ({ current, onChanged }) => {
  const [open, setOpen] = useState(false);
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [cid, setCid] = useState(null);
  const [code, setCode] = useState("");
  const [busy, setBusy] = useState(false);
  const reset = () => { setOpen(false); setEmail(""); setPassword(""); setCid(null); setCode(""); };

  const send = async () => {
    setBusy(true);
    try { const { data } = await api.post("/profile/email/request", { new_email: email, password }); setCid(data.challenge_id); toast.success(`Code sent to ${data.new_email}`); }
    catch (e) { toast.error(formatApiError(e.response?.data?.detail)); } finally { setBusy(false); }
  };
  const confirm = async () => {
    setBusy(true);
    try {
      const { data } = await api.post("/profile/email/confirm", { challenge_id: cid, code });
      localStorage.setItem("mc_agency_token", data.token);
      toast.success(`Your login email is now ${data.email}`); reset(); onChanged?.(data.email);
    } catch (e) { toast.error(formatApiError(e.response?.data?.detail)); } finally { setBusy(false); }
  };

  if (!open) return <button data-testid="profile-change-email" onClick={() => setOpen(true)} className="mt-1 flex items-center gap-1 text-xs text-[#5b2fd6] hover:text-[#723FFF]"><Mail className="h-3 w-3" /> Change email</button>;
  return (
    <div className="mt-3 rounded-2xl border border-[#EEEFEF] bg-[#FCFCFE] p-3 space-y-2" data-testid="profile-change-email-form">
      {!cid ? <>
        <p className="text-xs text-[#595D62]">Your login email is <b>{current}</b>. We'll send a code to the new address to confirm it.</p>
        <Input data-testid="change-email-new" type="email" value={email} onChange={(e) => setEmail(e.target.value)} placeholder="New email" className="bg-white border-[#EEEFEF] h-9" />
        <Input data-testid="change-email-password" type="password" value={password} onChange={(e) => setPassword(e.target.value)} placeholder="Current password" className="bg-white border-[#EEEFEF] h-9" />
        <div className="flex gap-2 justify-end">
          <Button data-testid="change-email-cancel" variant="ghost" size="sm" onClick={reset} className="rounded-full">Cancel</Button>
          <Button data-testid="change-email-send" size="sm" onClick={send} disabled={busy || !email.trim() || !password} className="bg-[#06060C] text-white hover:bg-[#1c1c24] rounded-full">{busy ? <Loader2 className="h-3.5 w-3.5 animate-spin" /> : "Send code"}</Button>
        </div>
      </> : <>
        <p className="text-xs text-[#595D62]">Enter the 6-digit code we sent to <b>{email.trim().toLowerCase()}</b>. It expires in 10 minutes.</p>
        <Input data-testid="change-email-code" inputMode="numeric" maxLength={6} value={code} onChange={(e) => setCode(e.target.value.replace(/\D/g, ""))} placeholder="123456" className="bg-white border-[#EEEFEF] h-9 tracking-[0.3em] font-mono-data" />
        <div className="flex gap-2 justify-end">
          <Button data-testid="change-email-back" variant="ghost" size="sm" onClick={() => { setCid(null); setCode(""); }} className="rounded-full">Back</Button>
          <Button data-testid="change-email-confirm" size="sm" onClick={confirm} disabled={busy || code.length !== 6} className="bg-[#06060C] text-white hover:bg-[#1c1c24] rounded-full">{busy ? <Loader2 className="h-3.5 w-3.5 animate-spin" /> : "Confirm new email"}</Button>
        </div>
      </>}
    </div>
  );
};
